module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/select-5c8e3b82e0ddd1f709e12c5ca11219b2.svg";